// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterClinic_root__28e5K"};